import axios from 'axios';
import Config from 'src/config';

// --- Produtos ---

export const v2_actionListarProdutos = (ownerId) => {
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/products?ownerId=${ownerId}`
    });
};

export const v2_actionCriarProduto = (data) => {
    // Enforce ownerId is string if not present
    if (!data.ownerId && data.cliente?._id) data.ownerId = data.cliente._id;

    return axios({
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/products`,
        data: data
    });
};

export const v2_actionEditarProduto = (id, data) => {
    return axios({
        method: "put",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/products/${id}`,
        data: data
    });
};

export const v2_actionDeletarProduto = (id) => {
    return axios({
        method: "delete",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/products/${id}`
    });
};

export const v2_actionObterProduto = (id) => {
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/products/${id}`
    });
};

export const v2_actionVerificarSkuExiste = (ownerId, sku, excludeProductId = null) => {
    let url = `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/products/check-sku?ownerId=${ownerId}&sku=${encodeURIComponent(sku)}`;
    if (excludeProductId) {
        url += `&excludeProductId=${excludeProductId}`;
    }
    return axios({
        method: "get",
        url
    });
};

export const v2_actionContarProdutos = (ownerId) => {
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/products/count?ownerId=${ownerId}`
    });
};


export const v2_actionImportarProdutos = (formData) => {
    return axios({
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/products/import`,
        data: formData,
        headers: { "Content-Type": "multipart/form-data" }
    });
};

// --- Categorias ---

export const v2_actionListarCategorias = (ownerId) => {
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/categories?ownerId=${ownerId}`
    });
};

export const v2_actionCriarCategoria = (data) => {
    return axios({
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/categories`,
        data: data
    });
};

export const v2_actionEditarCategoria = (id, data) => {
    return axios({
        method: "put",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/categories/${id}`,
        data: data
    });
};

export const v2_actionDeletarCategoria = (id) => {
    return axios({
        method: "delete",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/categories/${id}`
    });
};
